
import React from 'react';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <HowItWorks />
      <BeforeAfterGallery />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
